import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-brand">
            <img src="/logo.png" alt="DocuAIHub" className="footer-logo-image" />
            <p className="footer-description">
              AI-powered document tools for modern workflows
            </p>
            <div className="footer-legal-info">
              <p className="entity-name">AMB GLOBAL DIGITAL SOLUTIONS LTD</p>
              <p className="entity-details">1 Maiou 3, 2610 Agios Epifanios Oreinis, Cyprus</p>
              <p className="entity-details">Registration: CY12345678</p>
            </div>
          </div>

          <div className="footer-links">
            <div className="footer-group">
              <h4>Company</h4>
              <Link to="/en/about">About</Link>
              <Link to="/en/pricing">Pricing</Link>
              <Link to="/en/contact">Contact Us</Link>
              <Link to="/en/faq">FAQ</Link>
            </div>

            <div className="footer-group">
              <h4>Legal</h4>
              <Link to="/en/privacy">Privacy Policy</Link>
              <Link to="/en/terms">Terms of Service</Link>
              <Link to="/en/refund">Refund Policy</Link>
              <Link to="/en/cookies">Cookies Policy</Link>
            </div>

            <div className="footer-group">
              <h4>Features</h4>
              <a href="/lp/xbt1l">Convert Documents</a>
              <a href="/lp/xbt1l">Merge PDFs</a>
              <a href="/lp/xbt1l">Compress Files</a>
              <a href="/lp/xbt1l">AI Tools</a>
            </div>
          </div>

          <div className="footer-contact">
            <h4>Get in Touch</h4>
            <div className="contact-info">
              <a href="mailto:help@docuaihub.com" className="contact-item">
                ✉️ help@docuaihub.com
              </a>
              <a href="tel:+35777788373" className="contact-item">
                📞 +357 77788373
              </a>
              <a
                href="https://www.ambglobaldigital.com"
                target="_blank"
                rel="noopener noreferrer"
                className="contact-item"
              >
                🌐 www.ambglobaldigital.com
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="copyright">
            © {new Date().getFullYear()} DocuAIHub. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
